/** Component for product functions */
export function product() {
  var _THIS = this;
  this.elemContainer = null;
  this.ajaxProdInfo = null;
  this.selectedSKUObj = null;
  this.productData = null;
  this.addedPopupInstance = null;
  this.recentlyIns = null;
  var isQuickview = false;

  this.init = function (elemcontainer) {
    this.elemContainer = elemcontainer;
    this.productData = JSON.parse(
      $(_THIS.elemContainer + " .product-information").attr("data-product")
    );
    if ($(_THIS.elemContainer).hasClass("layout-quickview")) {
      isQuickview = true;
    }

    (async () => {
      const { recentlyViewed, initPromoFlags, initPromoNames,initComingSoonAddButton,initComingSoonFlag } = await import(
        theme.components.commonURL
      );

      if (!isQuickview) {
        _THIS.recentlyIns = new recentlyViewed();
        _THIS.recentlyIns.saveRecentlyViewed(_THIS.productData.handle);
      }

      initPromoFlags(_THIS.elemContainer + " .product-item-promo-flag");
      initPromoNames(_THIS.elemContainer + " .product-item-promo-name");


      initComingSoonAddButton(_THIS.elemContainer)
      initComingSoonFlag(_THIS.elemContainer + " .product-item-coming-soon-flag")

      if ($("#clkTrigger")) {
        $("#clkTrigger a").click();
      }
    })();

    registerEvents();
    sortVariantSize();
    $(".desktop .input_quantity").change(function () {
      var valQ = $(this).val();
      $(".mobile .input_quantity").val(valQ);
    });

    $(".mobile .input_quantity").change(function () {
      var valQ = $(this).val();
      $(".desktop .input_quantity").val(valQ);
    });
  };

  function sortVariantSize() {
    /* Sort variants - Size */
    var ul = $(".sizeList ul");
    var arr = $.makeArray(ul.children("li"));

    arr.sort(function (a, b) {
      var textA = +$(a).text();
      var textB = +$(b).text();

      if (textA < textB) return -1;
      if (textA > textB) return 1;

      return 0;
    });

    ul.empty();
    $.each(arr, function () {
      ul.append(this);
    });
  }

  this.getProductInformationByHandle = function (phandle, callback) {
    if (typeof _THIS.ajaxProdInfo !== "undefined") {
      if (_THIS.ajaxProdInfo !== null && _THIS.ajaxProdInfo !== "undefined") {
        _THIS.ajaxProdInfo.abort();
      }
    }

    _THIS.ajaxProdInfo = $.ajax({
      type: "GET",
      url:
        window.Shopify.routes.root +
        "products/" +
        phandle +
        "?view=customproduct.json",
      success: function (response) { 
        var json_response = JSON.parse(response);
        if (callback != null) return callback.call(this, json_response);
      },
      error: function (status) {
        console.warn("ERROR", status);
      },
    });
  };

  var displayProductAdded = function (addeddata) {
    if (typeof $.fancybox == "object") {
      $.fancybox.close("true");
    }

    //Hide any header menu
    $("body").removeClass("search-active");
    $("body").removeClass("myaccount-login-active");
    $("body").removeClass("menu-active");

    $("#search-dropdown").removeClass("active");
    $("#main-menu").removeClass("active");
    $("#myaccount-login").removeClass("active");

    var arrAdded = [];
    arrAdded.push(addeddata.handle);

    (async () => {
      const {
        getProductsInformation,
        getJsonProductInformation,
        headerBagIcon,
        miniCart,
      } = await import(theme.components.commonURL);

      var instHeaderBagIcon = new headerBagIcon();
      instHeaderBagIcon.updateBagIcon(null);
      getProductsInformation(arrAdded, false, function (data) {
        var htmlData = "";
        for (var i = 0; i < data.length; i++) {
          htmlData += data[i].response;
        }
        $("#added-product .added-product-image").html(htmlData);

        $("#added-product .added-product-title").html(addeddata.product_title);
        //As we want to limit the amount of ajax request
        //We display other added product info from the generated product card
        $("#added-product .added-product-style").html(
          $("#added-product .product-item-style").html()
        );

        //console.log(_THIS.productData)

        for (var i = 0; i < _THIS.productData.variants.length; i++) {
          if (_THIS.productData.variants[i].id == addeddata.id) {
            //console.log(_THIS.productData.variants[i])

            updateProductPrice("#added-product", _THIS.productData.variants[i]);
            break;
          }
        }

        //$("#added-product .added-product-price").html($("#added-product .product-price-wrap").html());
        if (_THIS.productData.product_type !== "Gift Card") {
          $("#added-product .added-product-colour")
            .removeClass("hide")
            .find("span")
            .html(addeddata.variant_options[0]);
          $("#added-product .added-product-size")
            .removeClass("hide")
            .find("span")
            .html(addeddata.variant_options[1]);
        } else {
          $("#added-product .added-product-colour")
            .addClass("hide")
            .find("span")
            .html("");
          $("#added-product .added-product-size")
            .addClass("hide")
            .find("span")
            .html("");
        }

        $("#added-product .added-product-quantity")
          .find("span")
          .html(addeddata.quantity);

        (async () => {
          var instHeadMiniCart = new miniCart();
          if (!$(document.body).hasClass("template-cart")) {
            if ($("#mini-cart-icon").hasClass("has-items")) {
              instHeadMiniCart.init();
              instHeadMiniCart.toggleDisplayMiniCart();
            }
          }
        })();
      });

      //You may also like

      getJsonProductInformation(addeddata.handle, function (ymldata) {
        var arrAlsoLikeProducts = [];
        var isHideYMAL = false;

        if (
          typeof ymldata.metafields.Linked_02 != "undefined" &&
          ymldata.metafields.Linked_02 !== null
        ) {
          //console.log("YMAL length: " + ymldata.metafields.Linked_02.length)
          if (ymldata.metafields.Linked_02.length > 0) {
            isHideYMAL = false;
            $(
              "#addedproduct-also-like, #added-product-ymal-title, .added-product-ymal-spacer"
            ).removeClass("hide");
            $("#added-product-wrapper").addClass("hasYMAL");
            arrAlsoLikeProducts.push.apply(
              arrAlsoLikeProducts,
              _THIS.productData.metafields.Linked_02
            );

            getProductsInformation(arrAlsoLikeProducts, true, function (pdata) {
              //updating the YMAL products
              if (arrAlsoLikeProducts.length > 0) {
                var htmlContentALPROD = "";
                for (var i = 0; i < arrAlsoLikeProducts.length; i++) {
                  if (i < 4) {
                    htmlContentALPROD += findCardHTMLContent(
                      arrAlsoLikeProducts[i]["value"],
                      pdata
                    );
                  }
                }
                $("#addedproduct-also-like .wrap-inner-slideshow").html(
                  htmlContentALPROD
                );
                (async () => {
                  const { default: models } = await import(
                    theme.components.modelsURL
                  );

                  // if(!isQuickview){
                  //We update the main image first
                  //console.log("updating media")
                  models.updateModelsDisplay(
                    "#addedproduct-also-like .product-media"
                  );
                  // }
                  //reconstructCarousel("#addedproduct-also-like",htmlContentALPROD,arrAlsoLikeProducts.length);
                })();
              }
            });
          } else {
            isHideYMAL = true;
          }
        } else {
          isHideYMAL = true;
        }

        if (isHideYMAL) {
          //we reset the Grid of the added product overlay content
          $("#addedproduct-also-like").addClass("hide");
          $("#added-product-info").addClass("width-lg-12");
        } else {
          $("#addedproduct-also-like").removeClass("hide");
          $("#added-product-info").removeClass("width-lg-12");
        }
      });
    })();
  };

  var renderProductFlags = function (salePrice, arrflags, promotions) {
    var arrFlagTagsType = theme.allFlagsList.split(",");
    var isFlagFound = false;
    var retFlagHtml = "";
    var flagPromotHtml = "";
    var flagClass = "";
    var flagClassS = "";
    var flagHtml = "";
    var flagHtmlS = "";
    var flagColor = "";
    var flagPromotionName = "";
    var flagPromotionStart = "";
    var flagPromotionEnd = "";
    var flagPromotionFlag = "";
    var isFlagPromoFound = false;

    var isFlagComingSoon = false;
    var flagHtmlComingSoonEnd = '';

    //Search for Promotion Flags
    var promotionsArr = promotions[0]; console.log(promotionsArr);
    if (
      promotionsArr &&
      promotionsArr.flagPromotionFlag &&
      promotionsArr.flagPromotionFlag !== ""
    ) {
      isFlagPromoFound = true;
      flagPromotionStart = promotionsArr.flagPromotionStart;
      flagPromotionEnd = promotionsArr.flagPromotionEnd;
      flagPromotionName = promotionsArr.flagPromotionName;
      flagPromotionFlag = promotionsArr.flagPromotionFlag;
      flagColor = promotionsArr.flagPromotionColor;
    }

    // Show item no - styleColour
    var itemNo = "";
    for (var j = 0; j < arrflags.length; j++) {
      var currentTagType = arrflags[j].split("--")[0];
      if ("StyleColour" == currentTagType) {
        itemNo = arrflags[j].split("--")[1];
      }
    }
    for (var i = 0; i < arrFlagTagsType.length; i++) {
      var searchFlagTagType = arrFlagTagsType[i];
      for (var j = 0; j < arrflags.length; j++) {
        var currentflagTagType = arrflags[j].split("--")[0];
        if (searchFlagTagType == currentflagTagType) {
          if (arrflags[j].split("--").length > 1) {
            var currentflagTagValue = arrflags[j].split("--")[1].toLowerCase();
          } else {
            var currentflagTagValue = arrflags[j].split("--")[0].toLowerCase();
          }

          if (currentflagTagValue == "yes") {
            isFlagFound = true;
            flagClass = searchFlagTagType.toLowerCase();
            switch (searchFlagTagType) {
              case "Exclusive":
                // code block
                flagHtml = theme.flags.online_exclusive;
                break;
              case "ComingSoon":
                isFlagComingSoon = true
                flagClass = flagClass  +  ' product-item-coming-soon-flag hide' 
                flagHtml = theme.flags.coming_soon;
                break;
              case "New":
                flagHtml = theme.flags.new;
                break;
              case "Outlet":
                flagHtml = theme.flags.outlet;
                break;
              case "Bestseller":
                flagHtml = theme.flags.bestseller;
                break;
              case "Sustainable":
                flagHtml = theme.flags.sustainable;
                break;
              default:
                flagHtml = "";
                break;
            }
          }
        }
      }
      if (isFlagFound) { console.log(searchFlagTagType+" searchFlagTagType "+currentflagTagValue);
        break;
      }
    }

      var searchFlagTagType = 'Sale';
      for (var j = 0; j < arrflags.length; j++) {
        var currentflagTagType = arrflags[j].split("--")[0];
        if (searchFlagTagType == currentflagTagType) {
          if (arrflags[j].split("--").length > 1) {
            var currentflagTagValue = arrflags[j].split("--")[1].toLowerCase();
          } else {
            var currentflagTagValue = arrflags[j].split("--")[0].toLowerCase();
          }

          if (currentflagTagValue == "yes") {
            isFlagFound = true;
            flagClassS = searchFlagTagType.toLowerCase(); console.log(searchFlagTagType+" searchFlagTagType");
            flagHtmlS = salePrice;
            break;
            }
          }
        }


    if(isFlagComingSoon){
      $(_THIS.elemContainer).find(".product-control-add").attr("data-iscomingsoon","true")

      for (var j = 0; j < arrflags.length; j++) {
        var currentTagType = arrflags[j].split("--")[0];
        if ("ComingSoonEnd" == currentTagType) {
          flagHtmlComingSoonEnd = arrflags[j].split("--")[1];
          $(_THIS.elemContainer).find(".product-control-add").attr("data-iscomingsoon-edate",flagHtmlComingSoonEnd)
        }
      }

    }

    /*
        if (theme.productsPromotion.global.enabled){
            isFlagPromoFound = false;
            if(theme.productsPromotion.global.flag!==''){
                isFlagPromoFound = true;
                flagPromotionFlag = theme.productsPromotion.global.flag;
            }
            flagPromotionStart 	= theme.productsPromotion.global.date_start;
            flagPromotionEnd 	= theme.productsPromotion.global.date_end;
        }
        */
    $(".product-info-value").text(itemNo);
    for (var j = 0; j < arrflags.length; j++) {
      var currentflagTagType = arrflags[j].split("--")[0];
    }
    //console.log(isFlagPromoFound);
    if (isFlagPromoFound) {
      flagPromotHtml +=
        '<div data-promo-start="' +
        flagPromotionStart +
        '" data-promo-end="' +
        flagPromotionEnd +
        '" class="product-item-promo-flag hide"><span class="flag promotion" style="background-color:' +
        flagColor +
        '">' +
        flagPromotionFlag +
        "</span></div>";
    }

    if (isFlagFound) {
      if (flagHtml != "" || flagHtmlS != "") {
        retFlagHtml +='<div class="product-item-flag' +(isFlagPromoFound ? " hide" : "") + '">' 
          if(flagHtmlComingSoonEnd!==""){
            retFlagHtml +='<span class="flag ' +  flagClass  + '" data-iscomingsoon="true" data-iscomingsoon-edate="' +  flagHtmlComingSoonEnd  + '" >' +  flagHtml  + '</span>'
            retFlagHtml +=        '<div class="available-from-item-info hide">'
            retFlagHtml +=            '<span class="label-item">&nbsp;</span><span class="available-from-item"></span>'
            retFlagHtml +=        '</div>'

          }else{
            if (flagHtml != ""){
            retFlagHtml +='<span class="flag ' +flagClass +'">' +flagHtml + "</span>"
            } 
            if (flagHtmlS != ""){
              retFlagHtml +='<span class="flag ms-1 ' +flagClassS +'">' +flagHtmlS + "</span>"
              } 
          }
          

        retFlagHtml += "</div>";
      }
    }

    return flagPromotHtml + retFlagHtml;
  };

  var renderProductPromoName = function (pproducttype, arrflags, pmetafields) {
    var flagPromotionName = "";
    var isFlagPromoNameFound = false;
    var flagPromotHtml = "";
    var flagWarehouse = false;
    var flagPromotionStart = "";
    var flagPromotionEnd = "";
    var promotionDetails = arrflags[0]; //console.log(promotionDetails.flagPromotionFlag);
    //flagPromotHtml += '<div data-promo-start="' + flagPromotionStart+'" data-promo-end="' + flagPromotionEnd  + '" class="product-item-promo-name hide"><span class="promotion' + promoclass + '"' + promoterms +'>' + flagPromotionName + '</span>' + promoicon + '</div>';
    if (promotionDetails) {
      flagPromotionName = promotionDetails.flagPromotionName;
      flagPromotionStart = promotionDetails.flagPromotionStart;
      flagPromotionEnd = promotionDetails.flagPromotionEnd;
      if (flagPromotionName) {
        flagPromotHtml +=
          '<div class="product-item-promo-name hide" data-promo-start="' +
          flagPromotionStart +
          '" data-promo-end="' +
          flagPromotionEnd +
          '"><span class="promotion">' +
          flagPromotionName +
          "</span></div>";
      }
    }
    return flagPromotHtml;
  };

  /**
   * Updating price
   * @param {*} container
   * @param {*} selvariantobj
   */
  var updateProductPrice = function (container, selvariantobj) {
    var elemContainer = _THIS.elemContainer;
    if (container !== null) {
      elemContainer = container;
    }

    var priceContainer = $(elemContainer + " .product-price-wrap");
    //Update Price
    var pricehtml = "";
    var compare_at_price = selvariantobj.compare_at_price.replace(/,/g, "");
    var price = selvariantobj.price.replace(/,/g, "");
    pricehtml +=
      '<div class="product-price' +
      (compare_at_price > price ? " price-on-sale" : "") +
      '">';
    pricehtml +=
      '<span class="regPrc"><span class="prcLbl">' +
      theme.strings.regularPrice +
      '</span><span class="price-item' +
      (parseInt(compare_at_price) > parseInt(price) ? " pre-sale" : "") +
      '">';

    if (parseInt(compare_at_price) > parseInt(price)) {
      pricehtml += selvariantobj.compare_at_price_currency;
    } else {
      pricehtml += selvariantobj.price_currency;
    }
    pricehtml += "</span></span>";
    //console.log(parseInt(compare_at_price) + ">" + price);
    if (parseInt(compare_at_price) > parseInt(price)) {
      pricehtml +=
        '<span class="salePrc"><span class="prcLbl">' +
        theme.strings.salePrice +
        '</span><span class="price-item sale">' +
        selvariantobj.price_currency +
        "</span></span>";
    }
    pricehtml += "</div>";
    priceContainer.html(pricehtml);

    //Update AfterPay Price
    $(elemContainer + " .afterPayPrice").html(selvariantobj.afterpayprice);
  };

  var updateQuantityInput = function (selvariantobj) {
    //console.log(_THIS.selectedSKUObj)
    if (_THIS.selectedSKUObj == null) {
      //we prevent quantity update unless a size is selectec
      $(
        _THIS.elemContainer + " .product-control-quantity input.input_quantity"
      ).attr("max", "1");
      $(_THIS.elemContainer + " .product-control-quantity a.minus").addClass(
        "disabled"
      );
      $(_THIS.elemContainer + " .product-control-quantity a.plus").addClass(
        "disabled"
      );
      $(
        _THIS.elemContainer + " .product-control-quantity input.input_quantity"
      ).val("1");
    } else {
      $(
        _THIS.elemContainer + " .product-control-quantity input.input_quantity"
      ).attr("max", selvariantobj.inventory_quantity);
      $(_THIS.elemContainer + " .product-control-quantity a.minus").removeClass(
        "disabled"
      );
      $(_THIS.elemContainer + " .product-control-quantity a.plus").removeClass(
        "disabled"
      );
      $(
        _THIS.elemContainer + " .product-control-quantity input.input_quantity"
      ).val("1");
    }
  };

  var resetStockIndicator = function () {
    //Show/hide stock indicator
    $(
      _THIS.elemContainer +
        " .product-stock-indicator .stock-indicator-available"
    ).addClass("hide");
    $(
      _THIS.elemContainer +
        " .product-stock-indicator .stock-indicator-limit .stock-remaining"
    ).val("");
    $(
      _THIS.elemContainer + " .product-stock-indicator .stock-indicator-limit"
    ).addClass("hide");
    $(_THIS.elemContainer + " .product-stock-indicator").addClass("hide");
  };
  var updateStockIndicator = function (selvariantobj) {
    resetStockIndicator();
    if (selvariantobj.available) {
      $(_THIS.elemContainer + " .product-stock-indicator").removeClass("hide");
      if (selvariantobj.inventory_quantity > 3) {
        $(
          _THIS.elemContainer +
            " .product-stock-indicator .stock-indicator-available"
        ).removeClass("hide");
      } else {
        $(
          _THIS.elemContainer +
            " .product-stock-indicator .stock-indicator-limit .stock-remaining"
        ).text(selvariantobj.inventory_quantity);
        $(
          _THIS.elemContainer +
            " .product-stock-indicator .stock-indicator-limit"
        ).removeClass("hide");
      }
    } else {
      $(_THIS.elemContainer + " .product-stock-indicator").addClass("hide");
    }
  };

  var updateAddToBagDisplay = function (selvariantobj) {

    $(_THIS.elemContainer + " .product-form-controls button[name=add]").prop("disabled",true);
    $(_THIS.elemContainer + " .product-form-controls button[name=add]").addClass("btn")
    
    //Check the product availablity
    var isAvailable = true;

    if (!_THIS.productData.available) {
      isAvailable = false;
    } else {
      if (!selvariantobj.available || 0 == selvariantobj.inventory_quantity) {
        isAvailable = false;
      }
    }

    if (isAvailable) {
      $(_THIS.elemContainer + " .product-form-controls").removeClass("size-not-available");

      if(!$(_THIS.elemContainer).hasClass("comingsoonactive")){
        $(_THIS.elemContainer + " .product-form-controls button[name=add]").prop("disabled",false);
        
      }else{
        $(_THIS.elemContainer + " .product-form-controls button[name=add]").prop("disabled",true);
        $(_THIS.elemContainer + " .product-form-controls button[name=add]").removeClass("btn")
      }
      $(_THIS.elemContainer +" .product-form-controls button[name=add] span.cartTxt").text(theme.strings.addToCart);

    } else {
      var bis =
        '<a href="#" class="BIS_trigger custom-BIS btn btn-primary heading-03-01 regularBtn btn-block" data-variant-id="' +
        selvariantobj.id +
        '" data-product-handle="' +
        _THIS.productData.handle +
        '">' +
        theme.strings.BIS +
        "</a>";
      $(_THIS.elemContainer + " .product-form-controls").addClass(
        "size-not-available"
      );
      //$(_THIS.elemContainer + ' .custom-BIS').attr("data-product-handle",_THIS.productData.handle);
      //$(_THIS.elemContainer + ' .custom-BIS').attr("data-product-data",JSON.stringify(_THIS.productData));
      $(_THIS.elemContainer + " .backinstore-wrapper").html(bis);
      //$(_THIS.elemContainer + ' .product-form-controls button[name=add] span.cartTxt').text(theme.strings.soldOut);
      //$(_THIS.elemContainer + ' .product-form-controls button[name=add]').prop("disabled",true)
    }
  };

  var updateProductSKU = function (elem) {
    var sizeElemCon = elem.parent();
    _THIS.selectedSKUObj = {
      upi: sizeElemCon.attr("data-variant-barcode"),
      variantid: sizeElemCon.attr("data-variant-id"),
      inventory: sizeElemCon.attr("data-variant-inventory"),
    };
    var variantobj = _THIS.productData.variants;
    var vlength = variantobj.length;
    for (var i = 0; i < vlength; i++) {
      if (variantobj[i].id == _THIS.selectedSKUObj.variantid) {
        //updateUPI(variantobj[i])
        //updateBISID(variantobj[i]);
        updateProductPrice(null, variantobj[i]);
        updateStockIndicator(variantobj[i]);
        updateAddToBagDisplay(variantobj[i]);
        updateQuantityInput(variantobj[i]);

        var selSizeName = variantobj[i].option2;
        //console.log(_THIS.productData)
        if (_THIS.productData.product_type == "Gift Card") {
          selSizeName = variantobj[i].price_currency;
        }

        $(_THIS.elemContainer + " .sel-size-name").html(selSizeName);

        break;
      }
    }
  };

  var updateProductCarousels = function () {
    (async () => {
      const { getProductsInformation, onlyUniqueHandle } = await import(
        theme.components.commonURL
      );

      var arrAllExtraProductsHandles = [];
      var arrMatchinLineProducts = [];
      var arrAlsoLikeProducts = [];

      if (
        typeof _THIS.productData.metafields.Linked_01 != "undefined" &&
        _THIS.productData.metafields.Linked_01 !== null
      ) {
        if (_THIS.productData.metafields.Linked_01.length > 0) {
          arrAllExtraProductsHandles.push.apply(
            arrAllExtraProductsHandles,
            _THIS.productData.metafields.Linked_01
          );
          arrMatchinLineProducts.push.apply(
            arrMatchinLineProducts,
            _THIS.productData.metafields.Linked_01
          );
        }
      }

      if (
        typeof _THIS.productData.metafields.Linked_02 != "undefined" &&
        _THIS.productData.metafields.Linked_02 !== null
      ) {
        if (_THIS.productData.metafields.Linked_02.length > 0) {
          arrAllExtraProductsHandles.push.apply(
            arrAllExtraProductsHandles,
            _THIS.productData.metafields.Linked_02
          );
          arrAlsoLikeProducts.push.apply(
            arrAlsoLikeProducts,
            _THIS.productData.metafields.Linked_02
          );
        }
      }

      if (arrAllExtraProductsHandles.length > 0) {
        var uniquearrAllExtraProductsHandles = onlyUniqueHandle(
          arrAllExtraProductsHandles
        );

        getProductsInformation(
          uniquearrAllExtraProductsHandles,
          true,
          function (data) {
            //console.log(arrMatchinLineProducts)
            //updating the MATCHING LINE products
            if (arrMatchinLineProducts.length > 0) {
              var htmlContentMLPROD = "";
              for (var i = 0; i < arrMatchinLineProducts.length; i++) {
                htmlContentMLPROD += findCardHTMLContent(
                  arrMatchinLineProducts[i]["value"],
                  data
                );
              }
            }
            reconstructCarousel(
              "div[id$='__asseenon']",
              htmlContentMLPROD,
              arrMatchinLineProducts.length
            );

            //updating the YMAL products
            if (arrAlsoLikeProducts.length > 0) {
              var htmlContentALPROD = "";
              for (var i = 0; i < arrAlsoLikeProducts.length; i++) {
                htmlContentALPROD += findCardHTMLContent(
                  arrAlsoLikeProducts[i]["value"],
                  data
                );
              }
            }
            reconstructCarousel(
              "div[id$='__related']",
              htmlContentALPROD,
              arrAlsoLikeProducts.length
            );
          }
        );
      }
    })();
  };

  var reconstructCarousel = function (elem, htmlContent, totalslides) {
    //console.log("reconstructing carousel" + elem)
    //get the parent container of carousel
    var carouselParent = $(elem);
    var carousel = carouselParent.find(".wrap-inner-slideshow");

    carousel.html(htmlContent);

    (async () => {
      const { carousel } = await import(theme.components.commonURL);
      var instCarousel = new carousel();
      instCarousel.init(elem);
    })();

    (async () => {
      const { default: models } = await import(theme.components.modelsURL);

      if (!isQuickview) {
        //We update the main image first

        models.updateModelsDisplay(elem + " .product-media");
      }
    })();
  };
  var findCardHTMLContent = function (handle, data) {
    var retVal = "";
    for (var i = 0; i < data.length; i++) {
      if (data[i].handle == handle) {
        retVal = data[i].response;
        break;
      }
    }
    return retVal;
  };

  var updateProductDisplay = function () {

    $(_THIS.elemContainer).removeClass("comingsoonactive")
    $(_THIS.elemContainer).find(".product-control-add").attr("data-iscomingsoon","false")
    $(_THIS.elemContainer).find(".product-control-add").attr("data-iscomingsoon-edate","")


    var isBackInStore = false;
    var datatagslength = _THIS.productData.tags.length;
    for (var t = 0; t < datatagslength; t++) {
      var dnTags = _THIS.productData.tags[t].toLowerCase();
      if (dnTags == "lifecycle--ongoing") {
        isBackInStore = true;
        break;
      }
    }


    

    if (isBackInStore) {
      $(_THIS.elemContainer + " .product-information").addClass("backinstock");
    } else {
      $(_THIS.elemContainer + " .product-information").removeClass(
        "backinstock"
      );
    }

    $(_THIS.elemContainer + " a.custom-BIS").attr(
      "data-product-handle",
      _THIS.productData.handle
    );

    if (_THIS.productData.available) {
      $(_THIS.elemContainer + " .product-information")
        .addClass("productavailable")
        .removeClass("productnotavailable");
    } else {
      $(_THIS.elemContainer + " .product-information")
        .removeClass("productavailable")
        .addClass("productnotavailable");
    }

    //Clear selected size
    $(_THIS.elemContainer + " .sel-colour-name").html("");

    //Updating product Images
    if (_THIS.productData.metafields.Models !== null) {
      $(_THIS.elemContainer + " .product-media").attr(
        "data-models",
        _THIS.productData.metafields.Models
      );
    }

    (async () => {
      const { default: models } = await import(theme.components.modelsURL);

      if ($(_THIS.elemContainer).hasClass("layout-quickview")) {
        //We update the main image first
        models.updateQuickViewModelsDisplay();
      } else {
        //We update the main image first
        models.updateModelsDisplay(_THIS.elemContainer + " .product-media");
      }
      //Then we recreate all related
    })();

    //Updating Product Name

    //Updating Product Style

    //Update Colour Name
    var getColourName = _THIS.productData.variants[0].option1;
    $(_THIS.elemContainer + " .sel-colour-name").html(
      getColourName.toLowerCase()
    );

    //Resetting Size Name
    $(_THIS.elemContainer + " .sel-size-name").html("");
    //Reset Stock Indicator
    resetStockIndicator();

    //Updating Product Sizes
    //Get update the size variation correspoding to selected colour
    var getSizeHtml = "<ul>";

    //var wishlistIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.13984 11.747L11.9949 18.5L18.8667 11.747C20.3865 10.2275 20.3734 7.6672 18.8536 6.14773C17.3338 4.62827 14.7525 4.62827 13.2327 6.14773L11.9949 7.49506L10.7441 6.1396C9.22429 4.62013 6.65963 4.62013 5.13984 6.1396C3.62005 7.65906 3.62005 10.2275 5.13984 11.747Z" stroke="#164196" stroke-width="2"/></svg>';

    //itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
    var optionHTML = "";
    var dv = _THIS.productData.variants;
    var selectedVariantObj = null;
    var dvlength = dv.length;
    for (var i = 0; i < dvlength; i++) {
      if (selectedVariantObj == null) {
        if (dv[i].selected) {
          selectedVariantObj = dv[i];
        }
      }
      var wishlistIcon =
        "<!-- include 'wishlist-button-collection' with '" + dv[i].id + "' -->";
      if (dv[i].available) {
        optionHTML +=
          '<option data-variant-id="' +
          dv[i].id +
          '" value="' +
          dv[i].id +
          '" data-variant-inventory="' +
          dv[i].inventory_quantity +
          '">' +
          dv[i].option2 +
          "</option>";
        getSizeHtml +=
          '<li class="sizeoption" data-variant-id="' +
          dv[i].id +
          '" value="' +
          dv[i].id +
          '" data-variant-barcode="' +
          (typeof dv[i].barcode !== "undefined" ? dv[i].barcode : "") +
          '" data-variant-inventory="' +
          dv[i].inventory_quantity +
          '"><a href="#" class="technical-01-medium">' +
          dv[i].option2 +
          "</a></li>";
      } else {
        optionHTML +=
          '<option data-variant-id="' +
          dv[i].id +
          '" value="' +
          dv[i].id +
          '" data-variant-inventory="' +
          dv[i].inventory_quantity +
          '">' +
          dv[i].option2 +
          " - " +
          (isBackInStore ? theme.strings.notifyMe : theme.strings.soldOut) +
          "</option>";
        getSizeHtml +=
          '<li class="sizeoption ' +
          (isBackInStore ? "notifyme" : "soldout") +
          '" data-variant-id="' +
          dv[i].id +
          '" value="' +
          dv[i].id +
          '" data-variant-barcode="' +
          (typeof dv[i].barcode !== "undefined" ? dv[i].barcode : "") +
          '" data-variant-inventory="' +
          dv[i].inventory_quantity +
          '"><a href="#" class="technical-01-medium">' +
          dv[i].option2 +
          (isBackInStore
            ? '<span class="icon-notify">' + theme.icons.email + "</span>"
            : "") +
          "</a></li>";
      }
    }

    getSizeHtml += "</ul>";

    $(_THIS.elemContainer + " .sizeList").html(getSizeHtml);
    $(_THIS.elemContainer + " select[name=id]").html(optionHTML);

    //when Loading a new colour we need to update  any previous selected sku info from previous colour
    //get the selected variant
    updateProductPrice(null, selectedVariantObj);
    updateQuantityInput(selectedVariantObj);

    //Updating Product Add To Bag
    updateAddToBagDisplay(selectedVariantObj);

    //Updating Related Products
    if (!$(_THIS.elemContainer).hasClass("layout-quickview")) {
      updateProductCarousels();
    }
    //Update Product Tags and Promotion Name
    //Get the product flag
    var productFlagHTML = renderProductFlags(
      _THIS.productData.sale_price,
      _THIS.productData.tags,
      _THIS.productData.promotions
    );

    //Get the Promotion Name
    var productPromoHTML = renderProductPromoName(
      _THIS.productData.product_type,
      _THIS.productData.promotions,
      _THIS.productData.metafields
    );

    $(_THIS.elemContainer).find(".product-item-flag").remove();
    $(_THIS.elemContainer).find(".product-item-promo-flag").remove();

    if (productFlagHTML !== "") {
      $(_THIS.elemContainer).find(".product-images").after(productFlagHTML);
    }

    $(_THIS.elemContainer).find(".product-item-promo-name").remove();
    if (productPromoHTML !== "") {
      $(_THIS.elemContainer)
        .find(".product-item-swatches")
        .before(productPromoHTML);
    }

    (async () => {
      const { initPromoFlags, initPromoNames, initComingSoonFlag ,initComingSoonAddButton} = await import(
        theme.components.commonURL
      );

      initPromoFlags(_THIS.elemContainer + " .product-item-promo-flag");
      initPromoNames(_THIS.elemContainer + " .product-item-promo-name");
      initComingSoonAddButton(_THIS.elemContainer)
      initComingSoonFlag(_THIS.elemContainer + " .product-item-coming-soon-flag")
      
    })();
  };

  var setSelectedElement = function (elem) {
    elem.parent().siblings().removeClass("sel");
    elem.parent().addClass("sel");
  };

  var selectColour = function (elem) {
    setSelectedElement(elem);
    _THIS.selectedSKUObj = null;
    _THIS.getProductInformationByHandle(
      elem.attr("data-product-handle"),
      function (data) {
        (async () => {
          if (data) {
            updateVideo(data.metafields);
          }
        })();
        _THIS.productData = data;
        updateProductDisplay();
        sortVariantSize();
      }
    );
  };

  var addToBagValidate = function (msg) {
    $(_THIS.elemContainer + " .product-add-indicator")
      .removeClass("hide")
      .html(msg)
      .show();

    if (!$("#viewport").is(":visible")) {
      if (!isQuickview) {
        $("html, body").animate(
          {
            scrollTop:
              $(".sizeHeader").offset().top -
              $("#shopify-section-header").height(),
          },
          1000
        );
      }
    }

    $(_THIS.elemContainer + " .product-add-indicator")
      .delay(3000)
      .fadeOut(1000, "linear", function () {
        $(_THIS.elemContainer + " .product-add-indicator")
          .html("")
          .addClass("hide");
      });
  };

  var displaySizeChartPopup = function (elem) {
    var title = elem.text();
    var brand = escape(elem.attr("data-size-guide-brand").toLowerCase());
    var product_type = escape(elem.attr("data-size-guide-type").toLowerCase());
    var gender = escape(elem.attr("data-size-guide-gender").toLowerCase());
    var age = escape(elem.attr("data-size-guide-age").toLowerCase());
    var str = Math.random().toString(36).slice(2);

    (async () => {
      const { checkLibrary, emailValidate } = await import(
        theme.components.commonURL
      );
      checkLibrary($.fancybox, theme.components.modalLibraryURL, function () {
        $.fancybox.open(
          '<div id="sizechart-product-template" class="layout-sizechart hide ' +
            brand +
            '"><div class="wrap-content"><div class="inner-wrap"><div class="loader-content"><img src="' +
            theme.loaderImage +
            '" /></div><div class="sizechart-content"></div></div></div></div>',
          {
            beforeShow: function (instance, current) {
              $.ajax({
                type: "GET",

                url:
                  window.Shopify.routes.root +
                  "pages/size-chart?view=size-chart-table&cache=false&brand=" +
                  brand +
                  "&product_type=" +
                  product_type +
                  "&gender=" +
                  gender +
                  "&age=" +
                  age +
                  "&type=" +
                  str,
                success: function (response) {
                  console.log("success");
                  $("#sizechart-product-template .sizechart-content").html(
                    response
                  );
                  setTimeout(function () {
                    $("#sizechart-product-template").removeClass("hide");
                    $(
                      "#sizechart-product-template .wrap-content .inner-wrap .loader-content"
                    ).addClass("hide");
                  }, 500);
                },
                error: function (status) {
                  console.warn("ERROR", status);
                },
              });
            },
          }
        );
      });
    })();
  };

  var addToBag = function (elem) {
    if (
      $(_THIS.elemContainer + " .product-form-controls").hasClass(
        "size-not-available"
      )
    ) {
      //Silently exit the function
      //console.log("size is not available")
      return;
    }

    if ($(_THIS.elemContainer + " .product-form-controls").hasClass("adding")) {
      //Silently exit the function
      //console.log("currently adding")
      return;
    }

    if (_THIS.selectedSKUObj !== null) {
      var postAdddata = {
        quantity: $(_THIS.elemContainer + " .input_quantity").val(),
        id: _THIS.selectedSKUObj.variantid,
      };
      $(_THIS.elemContainer + " .product-form-controls").addClass("adding");
      $(
        _THIS.elemContainer +
          " .product-form-controls button[name=add] span.cartTxt"
      ).text(theme.strings.addingToCart);
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: postAdddata,
        dataType: "json",
        success: function (addeddata) {
          $(_THIS.elemContainer + " .product-form-controls").removeClass(
            "adding"
          );
          $(
            _THIS.elemContainer +
              " .product-form-controls button[name=add] span.cartTxt"
          ).text(theme.strings.addToCart);
          displayProductAdded(addeddata);
        },
        error: function (xhr, status, error) {
          //addToBagValidate(xhr.responseJSON.description);
          addToBagValidate("Already in cart!");
          $(_THIS.elemContainer + " .product-form-controls").removeClass(
            "adding"
          );
          $(
            _THIS.elemContainer +
              " .product-form-controls button[name=add] span.cartTxt"
          ).text(theme.strings.addToCart);
        },
      });
    } else {
      var messageValidation = theme.strings.selectSize;
      if (_THIS.productData.product_type == "Gift Card") {
        messageValidation = theme.strings.selectAmount;
      }

      addToBagValidate(messageValidation);
    }
  };

  var selectSize = function (elem) {
    setSelectedElement(elem);
    updateProductSKU(elem);
    
    
  };

  /*var selectTab = function(elem){
        setSelectedElement(elem)
        var getContentRefClass = "." + elem.attr("data-content") + "-content"
        $(_THIS.elemContainer + " .product-details .tab-content .content").addClass("hide")
        
        $(_THIS.elemContainer + " .product-details " + getContentRefClass).removeClass("hide")

    } */

  var updateVideo = function (meta) {
    if (meta.ProductVideo != null && typeof meta.ProductVideo !== "undefined") {
      $(".product-media").addClass("hasVideo");
      $(".product-media").attr("data-video", meta.ProductVideo);
    } else {
      $(".product-media").removeClass("hasVideo");
      $(".product-media").attr("data-video", "");
    }
  };

  var registerEvents = function () {
    //Clear registered events from memory, especially useful for quickiew as
    //multiple instances are created within a page
    $(document).off(
      "click",
      _THIS.elemContainer + " .product-form__cart-submit"
    );
    $(document).off("click", _THIS.elemContainer + " .product-item-swatches a");
    $(document).off("click", _THIS.elemContainer + " .sizeoption a");

    $(document).off("click", _THIS.elemContainer + " .sizeoption a");

    $(document).off("click", _THIS.elemContainer + " a.size-guide-link");

    $(document).off("click", _THIS.elemContainer + " .promo-term-popup");

    $(document).on(
      "click",
      _THIS.elemContainer + " .promo-term-popup",
      function (e) {
        var titlePopup = $(this).attr("data-title");
        var contentPopup = $(this).attr("data-content");

        (async () => {
          const { checkLibrary } = await import(theme.components.commonURL);

          checkLibrary(
            $.fancybox,
            theme.components.modalLibraryURL,
            function () {
              if (!isQuickview) {
                $.fancybox.close("true");
              }

              _THIS.popupInstance = $.fancybox.open(
                '<div class="promotionTermsPopup"><h2>' +
                  titlePopup +
                  "</h2><p>" +
                  contentPopup +
                  "</p> </div>",
                {
                  afterShow: function (instance, current) {},
                }
              );
            }
          );
        })();
      }
    );

    $(document).on(
      "click",
      _THIS.elemContainer + " a.size-guide-link",
      function (e) {
        e.preventDefault;
        displaySizeChartPopup($(this));
        return false;
      }
    );

    $(document).on(
      "click",
      _THIS.elemContainer + " .product-form__cart-submit",
      function (e) {
        e.preventDefault;
        addToBag($(this));
        return false;
      }
    );

    $(document).on(
      "click",
      _THIS.elemContainer + " .product-item-swatches a",
      function (e) {
        e.preventDefault;
        selectColour($(this));
        return false;
      }
    );

    $(document).on(
      "click",
      _THIS.elemContainer + " .sizeoption a",
      function (e) {
        e.preventDefault;
        selectSize($(this));
        return false;
      }
    );
  };
}

export function quickView() {
  var _THIS = this;
  this.elem = null;
  this.popupInstance = null;
  this.modelInstance = null;
  this.init = function () {
    $(document).on("click", ".quickview-link", function (e) {
      e.preventDefault();
      _THIS.elem = $(this);

      (async () => {
        const { checkLibrary } = await import(theme.components.commonURL);

        checkLibrary($.fancybox, theme.components.modalLibraryURL, function () {
          displayQuickview();
        });
      })();
    });
  };

  var getQuickviewHTML = function (phandle, callback) {
    $.ajax({
      type: "GET",
      url:
        window.Shopify.routes.root + "products/" + phandle + "?view=quickview",
      success: function (response) {
        if (callback != null) return callback.call(this, response);
      },
      error: function (status) {
        console.warn("ERROR", status);
      },
    });
  };

  var displayQuickview = function () {
    $.fancybox.close("true");

    _THIS.popupInstance = $.fancybox.open(
      '<div id="quickview-product-template" class="layout-quickview"><div class="wrap-content"><div class="loader-content"><img src="' +
        theme.loaderImage +
        '" /></div></div></div>',
      {
        afterShow: function (instance, current) {
          getQuickviewHTML(
            _THIS.elem.attr("data-product-handle"),
            function (qhtml) {
              (async () => {
                const { default: models } = await import(
                  theme.components.modelsURL
                );

                $("#quickview-product-template .wrap-content").html(qhtml);
                models.updateQuickViewModelsDisplay();

                var instProduct = new product();
                instProduct.init("#quickview-product-template");

                if ($("#clkTrigger")) {
                  console.log("testclick");
                  $("#clkTrigger a").click();
                }
              })();

              //Update the product link
              //$("#quickview-product-template .full-details a").attr("href",producturl)
            }
          );
        },
      }
    );
  };
}
